<template>
  <bita-modal
    id="visit-form"
    :title="title"
    :modal-lg="true"
    :is-loading="isLoading"
    @close="reset"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">

            <bita-select
              name="doctor_id"
              label="پزشک"
              rules="required"
              :validation-container-class="col6"
              :data-source="doctors"
              data-text-field="name"
              data-value-field="id"
              v-model="form.doctor_id"
            />

            <bita-datepicker
              type="date"
              name="date"
              label="تاریخ ویزیت"
              rules="required"
              :validation-container-class="col6"
              input-class="form-control"
              v-model="form.date"
              format="YYYY/MM/DD"
              display-format="jYYYY/jMM/jDD"
            />

            <bita-input
              type="time"
              name="start_time"
              label="ساعت شروع (مثال: 08:00)"
              rules="required"
              :validation-container-class="col4"
              input-class="form-control"
              v-model="form.start_time"
            />

            <bita-input
              type="time"
              name="end_time"
              label="ساعت پایان (مثال: 12:00)"
              rules="required"
              :validation-container-class="col4"
              input-class="form-control"
              v-model="form.end_time"
            />

            <bita-input
              type="number"
              name="duration"
              label="مدت هر نوبت (دقیقه)"
              rules="required"
              :validation-container-class="col4"
              input-class="form-control"
              v-model="form.duration"
            />

          </div>
          <div class="row mt-3">
            <div class="col-12 text-info">
              <i class="fas fa-info-circle"></i>
              سیستم به صورت خودکار از ساعت شروع تا پایان، نوبت‌های متوالی با مدت زمان مشخص شده را برای این پزشک ایجاد خواهد کرد.
            </div>
          </div>
        </div>
      </bita-form>
    </div>

    <div slot="footer">
      <bita-bootbutton
        type="primary"
        title="تولید نوبت‌ها"
        icon="fas fa-calendar-plus"
        btn-width="150px"
        @click.native="save"
      />
    </div>
  </bita-modal>
</template>

<script>
export default {
  props: {
    title: String,
    isLoading: Boolean,
    doctors: Array,
  },
  data() {
    return {
      col4: "col-lg-4",
      col6: "col-lg-6",
      form: {
        duration: 15 // مقدار پیش‌فرض
      },
    };
  },
  methods: {
    save() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-create", this.form);
        }
      });
    },
    reset() {
      this.form = { duration: 15 };
      this.$refs.form.reset();
    },
    setErrors(_errors) {
      this.$refs.form.setErrors(_errors);
    },
  },
};
</script>
